module.exports = __webpack_public_path__ + "ath_game_web/img/4.2.615f15da.png";